import { connect } from 'react-redux'
import { selectDraftMailbox } from 'ducks/drafts'
import { selectKnownMailboxes } from 'selectors/mailboxes/selectKnownMailboxes'
import { selectIsLoggingNewConversation } from 'selectors/page'
import FromRow from './view'

const select = state => ({
  mailboxes: selectKnownMailboxes(state),
  mailbox: selectDraftMailbox(state),
  isLogging: selectIsLoggingNewConversation(state),
})

export default connect(select, null)(FromRow)
